<template>
    <div id="znyxSystem">
        <!--banner区域-->
        <div class="bannerWrap">
            <div class="contentWrap">
                <div class="content">
                    <div class="contentTitle">智能营销系统</div>
                    <div class="contentVal">
                        <span>帮助金融企业构建优质的营销生态，从广告、转化、活跃、留存、到流失等用户生命周期数据</span>
                        <span>进行全面分析并优化，实现精细化的运营效果，从而达到精准营销的目的</span>
                    </div>
                    <button class="btn" @click="showAlertFlag=true">立即咨询</button>
                </div>
            </div>
        </div>
        <!--内容区-->
        <div class="znyxSystemConWrap">
            <!--例子-->
            <div class="exampleWrap">
                <div class="exampleBox">
                    <div class="left">
                        <div class="leftList" v-for="(item,index) in leftData" :key="index">
                            <div class="name">
                                {{item.name}} <span>{{item.work}}</span>
                            </div>
                            <div class="wordWrap" v-html="item.val"></div>
                        </div>
                    </div>
                    <div class="right">
                        <div class="rightTitle">更好、更快、更精准地营销</div>
                        <div class="rightList" v-for="(item,index) in rightData" :key="index"
                             @click="chooseExampleEvent(index)">
                            <span></span>
                            <p v-html="item.val"></p>
                        </div>
                    </div>
                </div>
            </div>
            <!--产品设计-->
            <div class="productWrap">
                <canvas id="canvasBox"></canvas>
                <div class="headline">产品设计</div>
                <div class="productListWrap">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <!-- slides -->
                        <swiper-slide>
                            <div class="productList">
                                <div class="numBox"><img src="../../assets/img/num/01.png"/></div>
                                <div class="listTitle">
                                    用户属性<br/>参数动态分析
                                </div>
                                <div class="listVal">
                                    数据分析师结合商业参数对营销产品的用户基本属性及行为标签搭建分析框架，并进行高质量的动态权重分析，还原市场与用户的真实需求，分析出有价值的参数，对构建用户动态全景画像提供优化支持、为营销决策人员作出分析支撑，帮助企业更好地利用数据运营和解决问题，使企业提升营销竞争力
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="productList">
                                <div class="numBox"><img src="../../assets/img/num/02.png"/></div>
                                <div class="listTitle">
                                    建立营销<br/>数学模型
                                </div>
                                <div class="listVal">
                                    以产品成功营销结果参数作为样本，用SHA256算法进⾏加密传输，通过多方合作数据源对样本的属性参数进⾏学习分类，以神经⽹络计算技术为基础进行机器学习，自动聚类+权重的机器分析还原出用户的真实场景需求，建⽴营销⽬标人群画像，设定对用户各维度能力的评级并输出该样本营销数学模型
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="productList">
                                <div class="numBox"><img src="../../assets/img/num/03.png"/></div>
                                <div class="listTitle">
                                    匹配用户需求<br/>与高效精准营销
                                </div>
                                <div class="listVal">
                                    基于得到的营销数学模型结合科学的业务分析架构，根据不同业务和营销目标，设定符合该业务需求的决策树方案，请求客户授权媒体及渠道进行精准的⽤户触达，让目标用户需求与企业服务之间进行高效精准匹配，实现端到端之间高效的自动化精准营销
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="productList">
                                <div class="numBox"><img src="../../assets/img/num/04.png"/></div>
                                <div class="listTitle">
                                    动态分析<br/>商业参数
                                </div>
                                <div class="listVal">
                                    数据分析师用“客群洞察系统的市场分析参数+舆情洞察系统的价值参数+该业务精准营销产出指标参数“作为商业参数的衡量基础，对营销过程中的转化细节及用户状况进行营销效果评估，基于智能营销系统产出的参数，动态地结合用户属性参数，作出分析并输出结果，确保监测到营销每个环节
                                </div>
                            </div>
                        </swiper-slide>
                        <swiper-slide>
                            <div class="productList">
                                <div class="numBox"><img src="../../assets/img/num/05.png"/></div>
                                <div class="listTitle">
                                    优化迭代行为、商业<br/>数据结构实现精准营销
                                </div>
                                <div class="listVal">
                                    用户属性参数与商业参数是相辅相成的关系。优化用户属性参数驱动商业参数提升，商业参数提升可改变用户属性参数的设计策略，这是一个循环的动态产品验证服务，达到预期服务效果即可形成服务闭环
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <!--按钮-->
                <div class="btnWrap">
                    <button class="leftB" @click="leftEvent" :disabled="swiperFlag"
                            :class="swiperFlag ? 'disClass' : '' ">
                        <i class="el-icon-arrow-left"></i>
                    </button>
                    <button class="rightB" @click="rightEvent" :disabled="!swiperFlag"
                            :class="swiperFlag ? '' : 'disClass' ">
                        <i class="el-icon-arrow-right"></i>
                    </button>
                </div>
            </div>
            <!--应用价值-->
            <div class="applicationValue">
                <div class="headline" style="margin-bottom: 50px;">应用价值</div>
                <div class="applicationValueBox">
                    <div class="applicationValueList">
                        <img src="../../assets/img/znyxSystem/广告.png"/>
                        <div class="listTitle">广告营销</div>
                        <div class="listVal">
                            基于整合企业参数或接入第三方参数，进行全方位分析与洞察，从根源上发现问题并灵活地制定以营销目标为中心而制定有价值的策略，提升广告转化率
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/znyxSystem/零售.png"/>
                        <div class="listTitle">营收行业</div>
                        <div class="listVal">
                            对零售用户进行客群建模，对关键行为参数进行细化分析，制定相应的营销方案，激发新用户的购买以及提升老用户的复购率，降低零售商品存货率、提高流通率
                        </div>
                    </div>
                    <div class="applicationValueList">
                        <img src="../../assets/img/znyxSystem/金融.png"/>
                        <div class="listTitle">金融行业</div>
                        <div class="listVal">
                            帮助金融企业构建优质的营销生态，从广告、转化、活跃、留存、到流失等用户生命周期数据进行全面分析并优化，达到精细化的运营效果，实现精准营销
                        </div>
                    </div>
                </div>
            </div>
            <!--案例-->
            <div class="caseWrap">
                <div class="headline">案例</div>
                <div class="caseBox">
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某白药联合巨头公司的成功营销.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某白药联合巨头公司的成功营销</div>
                            <div class="rightValText">
                                某白药联合巨头公司依托大数据技术进行了一场开业营销。主要是借助巨头公司的生态平台以及大数据技术来对电商用户进行数据采集和分析，包括用户行为的深层次了解用户的使用习惯和偏好，并针对用户主特征，结合产品特性策划营销思路，用这种方法使销量显著提升
                            </div>
                        </div>
                    </div>
                    <div class="caseList">
                        <img src="../../assets/img/exampleImg/某快时尚企业的营销战略.png" class="leftImg"/>
                        <div class="rightVal">
                            <div class="rightValTitle">某快时尚企业的营销战略</div>
                            <div class="rightValText">
                                某快时尚国际企业依托大数据的收集和精准分析结合市场制定营销战略：价格适宜，基础款为主，根据产品的销售情况进行适当地产量调整，举行时段性和周期性的品牌联合活动。进行实时的监控和分析，并据此来制定相应的产量和营销策略，减少损耗的成本，提高容错率，从而做到“零库存”
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--相关产品-->
            <div class="relevantProduct">
                <div class="headline">相关产品</div>
                <!--产品列表-->
                <div class="relevantProductListWrap">
                    <div class="relevantProductList" @click="toPage('/modelFactory')" style="margin-right: 144px;">
                        <img src="../../assets/img/bigIcon/模型工厂.png"/>
                        <span>模型工厂</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/factorServices')" style="margin-right: 144px;">
                        <img src="../../assets/img/bigIcon/因子服务.png"/>
                        <span>因子服务</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/smartLabel')" style="margin-right: 128px;">
                        <img src="../../assets/img/bigIcon/智能标签.png"/>
                        <span>智能标签</span>
                    </div>
                    <div class="relevantProductList" @click="toPage('/znkqdcSystem')">
                        <img src="../../assets/img/bigIcon/智能客群洞察系统.png"/>
                        <span>智能客群洞察系统</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="alertBox" v-show="showAlertFlag">
            <div class="alertBoxHeader">
                <span>服务咨询</span>
                <img src="../../assets/关闭.png" height="11" width="11" @click="showAlertFlag=false"/>
            </div>
            <div class="alertBoxVal">
                <div>为您提供售前购买咨询、产品推荐等</div>
                <p>电话：<span>0755-86969845</span>（工作日 9:30-18:30）</p>
                <p>微信：ylw2539</p>
                <p>邮箱：yu@houselai.com</p>
            </div>
        </div>

    </div>
</template>

<script>
    import znkqdxSystemFun from "../../assets/js/znkqdxSystem"

    import 'swiper/dist/css/swiper.css'
    import {swiper, swiperSlide} from 'vue-awesome-swiper'

    export default {
        name: "znyxSystem",
        components: {
            swiper,
            swiperSlide
        },
        data() {
            return {
                proIndex: 1,
                swiperOption: {
                    // 所有的参数同 swiper 官方 api 参数
                    slidesPerView: "auto",
                    spaceBetween: 100,
                    // 禁止鼠标滑动
                    simulateTouch: false,
                    // 距右侧的距离
                    slidesOffsetAfter: 30,
                    // 距左侧的距离
                    slidesOffsetBefore: 30,
                },
                btnFlag: false,
                swiperIndex: 0,
                swiperFlag: true,
                /*数据*/
                rightData: [
                    {val: "运营/优化师凭借经验创建广告计划？"},
                    {val: "客户转化率很低？"},
                ],
                allData: {
                    0: [
                        {
                            name: "方女士", work: "某公司运营总监",
                            val: "传统广告公司借助大数据时代走上变革的道路，而某些公司凭借大数据上优势" +
                                "，强势吞噬广告公司的生存空间。利用大数据，精准制定品牌策略，在媒介上，利" +
                                "用大数据优势获得广告资源，让广告革命提上了日程<br/>" +
                                "大数据对广告策略产生了深刻的影响，利用大数据进行更精准、更有效的策略制定，" +
                                "让广告变成了一个超高效的智能营销工具。"
                        },
                        {
                            name: "黄先生", work: "某资深广告优化师",
                            val: "以前做广告是找准方向摸着石头过河，现在广告就是用GPS定位，然后用声呐" +
                                "探测河中所有的危险，规划出最合理的路线。大数据对广告策略的影响是深刻的，" +
                                "从洞察消费者，到精准定位，再到做营销活动，这样的例子不胜枚举"
                        },
                        {
                            name: "赵女士", work: "某代理公司营销人员",
                            val: "以前商家在做好产品的同时，还要思考怎么样才能得知谁是消费群体、是什么" +
                                "样的群体、消费群体为什么会买产品、在哪儿购买、何地使用、定价该多少、该怎" +
                                "么做，然后费很大功夫做调研，再花费巨资请一家好的代理公司<br/>" +
                                "现在大数据时代来临，带来了一切数据，商家和代理公司只需对数据进行精炼洞察，" +
                                "并做出最接近事实的精准创意营销，使得广告发挥出最大效力"
                        }
                    ],
                    1: [
                        {
                            name: "李先生", work: "某电商店主",
                            val: "每年双11要讨论的不是“钱是怎么花掉的”，而是“那些热卖的电商商家的钱是怎么赚的”？<br/>" +
                                "我们都知道“数据驱动运营”这个大道理，大道理听多了，反而越来越多的人不知道如何" +
                                "用数据驱动运营，电商案例是最能说明“这个大道理的<br/>" +
                                "人为分析数据，机器学习分析数据输出结果，利用商业数据动态验证结果，基于数据不" +
                                "断迭代运营方案，打造智能营销系统，彻底摆脱转化率低的问题"
                        },
                        {
                            name: "万女士", work: "某购物网站运营主管",
                            val: "是否遇到过这种情况，商家网站有很多访客，但实际上很少有人购买产品？这可不是一" +
                                "个成功的网站。好消息是，如果有人进入这个网站，那么实际上网站的运营人员能够知" +
                                "道自己需要做什么来提高其销售数字<br/>" +
                                "如何做到这一点？当然是通过数据分析，通过分析访问识别有效的消费者，使用智能营销，" +
                                "制定定相应的解决方案提高销售的转换率"
                        },
                        {
                            name: "张先生", work: "某资深销售",
                            val: "怎么提高业绩？说什么可以增加订单？这些似乎只能是广大销售们自己说不清道不" +
                                "明的经验之谈。然而事实上，由于个人判断的局限性，每个销售所谓的“经验套路”很" +
                                "有可能并没有达到很好的效果，其实业绩还有很大的提升空间<br/>" +
                                "通过分析庞大的数据库得到针对不同领域、不同情境下转化率最佳的销售套路从而" +
                                "实现智能营销"
                        }
                    ],
                },
                leftData: [],
                showAlertFlag: false

            }
        },
        created() {
            /*初始化案例*/
            this.leftData = this.allData[0];
        },
        computed: {
            swiper() {
                return this.$refs.mySwiper.swiper
            }
        },
        mounted() {
            /*canvas 粒子背景*/
            znkqdxSystemFun();
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            scrollFun() {
                this.$animate(document.getElementsByClassName("content")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("exampleWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("productWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("applicationValue")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("caseWrap")[0], "fadeInUp");
                this.$animate(document.getElementsByClassName("relevantProduct")[0], "fadeInUp");
            },
            /*轮播左右按钮*/
            rightEvent() {
                this.swiperFlag = false;
                this.swiper.slideTo(4);
            },
            leftEvent() {
                this.swiperFlag = true;
                this.swiper.slideTo(0);
            },
            /*切换案例数据*/
            chooseExampleEvent(index) {
                this.leftData = this.allData[index];
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    /*设定 swiper 宽度*/
    .swiper-slide {
        width: 260px;
    }

    #znyxSystem {
        .bannerWrap {
            background: url("../../assets/img/znyxSystem/bg.png") no-repeat center;
            background-color: #00051D;

            .containerWrap {
                position: absolute;
                right: 100px;
                top: 50%;
                transform: translateY(-50%);
            }
        }

        .znyxSystemConWrap {
            .exampleWrap {
                background: url("../../assets/bgImg.png");
                background-size: cover;
                padding: 80px 0 120px;
            }

            .exampleBox {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                width: 1200px;
                margin: 0 auto 120px;
                padding: 0 0 0 76px;

                .left {
                    width: 458px;
                    padding-top: 44px;
                    margin-right: 128px;

                    .leftList {
                        padding: 20px 20px 20px 31px;
                        margin-bottom: 16px;
                        border-radius: 4px;
                        border: 1px solid #EAEEF4;
                        background: #fff;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        .name {
                            margin-bottom: 4px;
                            font-size: 14px;
                            color: #1B2D35;

                            span {
                                margin-left: 10px;
                                font-size: 12px;
                                color: #40B0FF;
                            }
                        }

                        .wordWrap {
                            opacity: 0.6;
                            margin-bottom: 4px;
                            font-size: 12px;
                            color: #152346;
                            text-align: justify;
                            line-height: 24px;

                            &:last-child {
                                margin-bottom: 0;
                            }
                        }
                    }
                }

                .right {
                    .rightTitle {
                        margin-bottom: 60px;
                        font-size: 30px;
                        color: #152346;
                    }

                    .rightList {
                        display: flex;
                        align-items: center;
                        margin-bottom: 40px;
                        line-height: 22px;
                        cursor: pointer;

                        &:last-child {
                            margin-bottom: 0;
                        }

                        span {
                            display: inline-block;
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            margin-right: 22px;
                            background: #22A5FF;
                        }

                        p {
                            font-size: 16px;
                            color: #152346;
                        }
                    }
                }
            }

            .productWrap {
                position: relative;
                min-width: 1200px;
                height: 680px;
                padding-top: 60px;
                background: #000519;

                .headline {
                    margin-bottom: 30px;
                    color: #FFFFFF;
                }

                #canvasBox {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    z-index: -1;
                }

                .shadowI {
                    position: absolute;
                    top: 50%;
                    transform: translateY(-50%);
                    right: 0;
                    z-index: 100;
                }

                .productListWrap {
                    position: relative;
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;
                    /*padding-left: 64px;*/

                    &:after {
                        position: absolute;
                        right: 0;
                        bottom: 0;
                        width: 70px;
                        height: 100%;
                        background-image: linear-gradient(270deg, #000519 0%, rgba(0, 5, 25, 0.00) 100%);
                        z-index: 100;
                        content: "";
                    }

                    &:before {
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 70px;
                        height: 100%;
                        background-image: linear-gradient(270deg, rgba(0, 5, 25, 0.00) 0%, #000519 100%);
                        z-index: 100;
                        content: "";
                    }

                    .productList {
                        position: relative;
                        width: 260px;

                        .numBox {
                            position: relative;
                            left: 0;
                            bottom: -30px
                        }

                        .listTitle {
                            position: relative;
                            z-index: 500;
                            margin-bottom: 24px;
                            font-size: 24px;
                            color: #FFFFFF;
                            line-height: 34px;
                        }

                        .listVal {
                            opacity: 0.8;
                            white-space: normal;
                            text-align: justify;
                            font-size: 12px;
                            color: #FDFDFD;
                            line-height: 22px;
                        }
                    }
                }
            }

            .applicationValue {
                background: url("../../assets/bgImg.png");
                background-size: cover;
                padding-top: 120px;
                padding-bottom: 114px;

                .applicationValueBox {
                    display: flex;
                    justify-content: space-between;
                    width: 1200px;
                    margin: 0 auto;

                    .applicationValueList {
                        width: 300px;
                        text-align: center;

                        img {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 24px;
                        }

                        .listTitle {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .listVal {
                            opacity: 0.7;
                            font-size: 12px;
                            color: #152346;
                            line-height: 22px;
                            text-align: justify;
                        }
                    }
                }
            }
        }

        .caseWrap {
            margin-top: 18px;

            .caseBox {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 1200px;
                margin: 0 auto;

                .caseList {
                    display: flex;
                    align-items: flex-start;

                    .leftImg {
                        width: 192px;
                        height: 186px;
                        margin-right: 16px;
                    }

                    .rightVal {
                        padding-top: 16px;

                        .rightValTitle {
                            opacity: 0.6;
                            margin-bottom: 10px;
                            font-size: 20px;
                            color: #152346;
                        }

                        .rightValText {
                            width: 339px;
                            opacity: 0.4;
                            font-size: 12px;
                            color: #152346;
                            line-height: 24px;
                        }
                    }
                }
            }
        }

        /*轮播按钮*/
        .btnWrap {
            display: flex;
            justify-content: space-between;
            width: 192px;
            margin: 65px auto 0;

            button {
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                width: 36px;
                height: 36px;
                font-size: 12px;
                border-radius: 50%;
                border: 1px solid #fff;
                background: transparent;

                i {
                    color: #fff;
                }
            }

            .disClass {
                border: 1px solid #999;

                i {
                    color: #999;
                }
            }
        }

        .relevantProduct {
            width: 740px;
        }
    }
</style>